"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEIZURE = exports.REPOSSESSION = exports.GARNISHMENT = exports.FORECLOSURE = exports.PENDING = exports.CONCLUDED = exports.APPEAL = void 0; // Status of case

exports.APPEAL = "appeal";
exports.CONCLUDED = "concluded";
exports.PENDING = "pending"; // Status of property

exports.FORECLOSURE = "foreclosure";
exports.GARNISHMENT = "garnishment";
exports.REPOSSESSION = "repossession";
exports.SEIZURE = "seizure";